import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectSignalsDescription } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

import createEcommerceSignalFiltersViewResolver from "../services/ecommerce-signals-filters-view-resolver/factory";

export default function useEcommerceSignalFiltersViewResolver() {
    const signalsDescription = useSelector(selectSignalsDescription);

    return useMemo(() => {
        return createEcommerceSignalFiltersViewResolver({
            ecommerce: signalsDescription?.ecommerce,
        });
    }, [signalsDescription?.ecommerce]);
}
